// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import gql from '@/graphql/gql';
import { ScoreFragmentDoc } from './ScoreFragment.generated';
export type TournamentFragment = { __typename?: 'CasinoTournamentsPublicTournament', id: string, enabled?: boolean, openAt?: any, closeAt?: any, iAmOptedIn?: boolean, name?: string, prizeText?: string, activityType?: string, shortUrl?: string, backgroundImageSmall?: string, backgroundImageLarge?: string, rules?: string, leaderboardType?: string, myScore?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean, leaderboardAfter?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }>, leaderboardBefore?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> }, prizes?: Array<{ __typename?: 'CasinoTournamentsPublicPrize', id: string, forPosition?: number, name?: string, link?: string, automaticallyReleased?: boolean }>, leaderboard?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> };

export type TournamentPrizeFragment = { __typename?: 'CasinoTournamentsPublicPrize', id: string, forPosition?: number, name?: string, link?: string, automaticallyReleased?: boolean };

export type MyScoreFragment = { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean, leaderboardAfter?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }>, leaderboardBefore?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> };

export const MyScoreFragmentDoc = gql`
    fragment MyScore on CasinoTournamentsPublicScore {
  ...ScoreFragment
  leaderboardAfter {
    ...ScoreFragment
  }
  leaderboardBefore {
    ...ScoreFragment
  }
}
    ${ScoreFragmentDoc}`;
export const TournamentPrizeFragmentDoc = gql`
    fragment TournamentPrize on CasinoTournamentsPublicPrize {
  id
  forPosition
  name
  link
  automaticallyReleased
}
    `;
export const TournamentFragmentDoc = gql`
    fragment TournamentFragment on CasinoTournamentsPublicTournament {
  id
  enabled
  openAt
  closeAt
  iAmOptedIn
  name
  prizeText
  activityType
  shortUrl
  backgroundImageSmall
  backgroundImageLarge
  rules
  myScore {
    ...MyScore
  }
  prizes {
    ...TournamentPrize
  }
  leaderboardType
  leaderboard {
    id
    username
    points
    position
    isMyScore
    canClaimPrize
  }
}
    ${MyScoreFragmentDoc}
${TournamentPrizeFragmentDoc}`;
